import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './ProgressBar.module.scss';

interface Props {
  marks: string[];
  onClick?: (i: number) => void;
}

const ProgressBar = ({ marks, onClick }: Props) => (
  <div
    className={`mb-3 d-grid ${styles.progress_bar}`}
    style={{
      gridTemplateColumns: `repeat(${marks.length}, 1fr)`,
    }}
  >
    {marks.map((backgroundColor, i) => (
      <OverlayTrigger
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        overlay={
          <Tooltip id={`progress-bar-mark-${i}`}>
            {i + 1} из {marks.length}
          </Tooltip>
        }
      >
        <div
          role="presentation"
          onClick={() => onClick?.(i)}
          className={styles.progress_bar__mark}
          style={{
            backgroundColor,
          }}
        />
      </OverlayTrigger>
    ))}
  </div>
);

ProgressBar.defaultProps = {
  onClick: () => {},
};

export default ProgressBar;
